import { Button, Dialog, Tooltip } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Mention, MentionsInput } from 'react-mentions';
import { onSubmitEditMsg } from '../handler/MessageHandler';
import './ChatInput.css';
import classNames from './CustomStyle.module.css';
import defaultMentionStyle from './defaultMentionStyle';
import { useSetRecoilState } from 'recoil';
import { isEditedMsgInprogressAtom } from '@/state/atom/panelAtom';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { CkeditorConfiguration } from '@/common/constant/CkEditorConfiguration';
import { I18n } from 'aws-amplify';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import { uploadFileToS3InTMPFolder } from '@/common/utils/UploadFileUtil'; 
import SpecialCharactersEmoji from '@/component/formManagement/fieldUI/SpecialCharactersEmoji';
import { Storage } from 'aws-amplify';
import CloseIcon from '@material-ui/icons/Close';
import FileIcon from '@material-ui/icons/InsertDriveFile';
import { PropTypes } from 'prop-types';
const path = require('path');

export default function EditChatPost({
    API,
    userListCanMention,
    userChatList,
    itemChatPost,
    setIsShowModalEditMsg,
    msgContentList,
    msgEditSelected,
    setEditedMsgList,
    setStatusDeleteMsgList,
    statusDeleteMsgList,
    chatPostAllList,
    setChatPostUpdate,
    notShowMention,
    ticketInfo,
    reloadTicketDetail,
    attachFiles,
    ...args
}) {
    const { userDetail, selectThread, corporationDetail } = args;
    let networkAvailable = navigator.onLine;
    const ckEditorId = Utils.generateRandomStr();

    const [isDisableBtnSave, setIsDisableBtnSave] = useState(true);
    let [listRenderMention, setListRenderMention] = useState([]);
    const [chatPostValue, setPostValue] = useState('');
    const [chatPostOriginal, setPostOriginal] = useState('');
    const editChatInputRef = useRef();
    const [ckEditorState, setCKEditorState] = useState(Utils.isValidJSONString('') ? JSON.parse('') : '');
    const [attachFilesDelete, setAttachFilesDelete] = useState([]);
    const [attachFilesCurrent, setAttachFilesCurrent] = useState([...attachFiles]);
    const [openPreviewImage, setOpenPreviewImage] = useState(null);

    const deleteFile = file => {
        setAttachFilesCurrent(attachFilesCurrent.filter(f => f !== file));
        setAttachFilesDelete(prev => [...prev, file])
    };

    const isDisableButtonSave = () => {
        const isEmailCustomerThread = isSelectedTicketTypeAndThreadType(
            Constant.TICKET_TYPE.EMAIL,
            Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD
        );
        if (isEmailCustomerThread) {
            if (
                chatPostOriginal.localeCompare(ckEditorState) === 0 ||
                !networkAvailable ||
                !ckEditorState ||
                Utils.cleanHtml(Utils.escapeHtmlCharacters(ckEditorState)).trim() === ''
            ) {
                return true;
            }
            return false;
        }

        if (
            ((chatPostOriginal.localeCompare(chatPostValue) === 0 || !networkAvailable) &&
                !attachFilesDelete.length) ||
            (Utils.isEmptyString(chatPostValue) &&
                (itemChatPost?.attachFiles?.length || 0) === attachFilesDelete.length)
        ) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        return () => {
            // cleanup
            setIsDisableBtnSave(true);
            setListRenderMention([])
            setPostValue('');
            setCKEditorState('');
            setPostOriginal('');
        };
    }, []);

    useEffect(() => {
        setIsDisableBtnSave(isDisableButtonSave());
    }, [chatPostValue, ckEditorState, attachFilesDelete, chatPostOriginal]);

    const setIsEditedMsgInprogress = useSetRecoilState(isEditedMsgInprogressAtom);
    useEffect(() => {
        setIsEditedMsgInprogress(!isDisableBtnSave);
    }, [isDisableBtnSave]);

    useEffect(() => {
        let listRenderMentionClone = [];

        if (!Utils.isEmptyArray(userListCanMention)) {
            userListCanMention?.forEach(user => {
                let renderTemplate = {};
                renderTemplate[`id`] = user.id;
                renderTemplate[`display`] =
                    user.id !== Constant.CHAT_MENTION_ALL.id
                        ? `${Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user)} ${user.mail}`
                        : `${Constant.CHAT_MENTION_ALL.name} all`;
                renderTemplate[`mail`] = user.mail;
                renderTemplate[`avatar`] = user.avatar;

                listRenderMentionClone.push(renderTemplate);
            });

            setListRenderMention(listRenderMentionClone);
        }
    }, [userListCanMention]);

    useEffect(() => {
        if (!Utils.isEmptyObject(msgEditSelected)) {
            let content = msgEditSelected.content;
            let mentionList = msgEditSelected.mention;

            let messageParser = [...content.matchAll(/@\[(.*?)]/g)];
            for (const part of messageParser) {
                if (mentionList.includes(part[1])) {
                    if (part[1] === Constant.CHAT_MENTION_ALL.id) {
                        content = content.replace(
                            `${part[0]}`,
                            `@[${Constant.CHAT_MENTION_ALL.name} ${Constant.CHAT_MENTION_ALL.name}](${Constant.CHAT_MENTION_ALL.id})`
                        );
                    } else {
                        let userMentionDetail = userChatList.find(user => user.id === part[1]);
                        let userFullName = Utils.getFullNameOfUser(
                            Constant.LANGUAGE_TYPE.JP,
                            userMentionDetail
                        );
                        content = content.replace(
                            `${part[0]}`,
                            `@[${userFullName} ${userMentionDetail.mail === Constant.DELETED_USER_NAME ? '' : userMentionDetail.mail}](${userMentionDetail.id})`
                        );
                    }
                }
            }
            setPostValue(content);
            setCKEditorState(content)
            setPostOriginal(content);
        }
    }, [msgEditSelected]);

    const onChangePost = e => {
        setPostValue(e.target.value);
    };

    const handleKeyDown = (e) => {
        if(e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            if(isDisableButtonSave()) return;
            onEditChatPost();
        }
    }

    const refactorChatPostContent = async chatPostContent => {
        const urls = Utils.getRichTextUrls(null, chatPostContent);
        const s3Keys = Utils.getKeyFileFromCDNLinks(urls) || [];
        let newUrls = [];
        const putFilesProcess = [];
        for (const s3Key of s3Keys) {
            const file = await Storage.get(s3Key?.keyFile.replace('/public/', ''), {
                download: true,
                cacheControl: 'no-cache'
            });
            const fileName = path.basename(s3Key?.keyFile.replace('/public/', ''));
            const currentTime = new Date();
            const s3ChatPostFilePath = `${corporationDetail?.id}/ticket/${
                selectThread?.ticketId
            }/chatThread/${selectThread?.id}/${userDetail?.id}/${currentTime.getTime()}/${fileName}`;
            putFilesProcess.push(
                Storage.put(s3ChatPostFilePath, file?.Body, {
                    level: 'public',
                    contentType: file?.ContentType
                })
            );
        }
        const s3PutFilesResult = await Promise.all(putFilesProcess);
        for (const s3PutFileResult of s3PutFilesResult) {
            const data = {
                id: Math.random(),
                fileUrl: s3PutFileResult?.key,
                chatThreadType: selectThread?.threadType,
                type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
                sharedRange: selectThread?.sharedRange
            };
            const newLink = getLinkDownloadFileFromS3(data, ticketInfo, null, null, false, false);
            newUrls.push(newLink);
        }
        let newChatPostContent = '';
        urls?.forEach((url, idx) => {
            newChatPostContent = newChatPostContent.replace(url, newUrls[idx] + `\\"`);
        });
        return chatPostContent;
    };

    const onEditChatPost = async () => {
        let chatPostContent = chatPostValue
        const isEmailCustomerThread = isSelectedTicketTypeAndThreadType(Constant.TICKET_TYPE.EMAIL, Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD);

        if (isEmailCustomerThread) chatPostContent = ckEditorState;

        let messageParser = [...chatPostContent.matchAll(/@\[(.*?)]\((.*?)\)/g)];
        const GET_MENTION_ID_REGEX = /(user_[a-z0-9\-]+|ALL)(?=\))/g
        let mentionsList = chatPostContent.match(GET_MENTION_ID_REGEX);

        let messageForSave = chatPostContent;
        for (const part of messageParser) {
            messageForSave = messageForSave.replace(`${part[0]}`, `@[${part[2]}]`);
        }
        // apply when chat post content is ckeditor data. apply for email customer thread. we can be apply more and more for future. start
        if(isEmailCustomerThread){
            messageForSave = await refactorChatPostContent(messageForSave);
        }
        // apply when chat post content is ckeditor data. apply for email customer thread. we can be apply more and more for future. end

        let formData = {
            msg: messageForSave
        };

        onSubmitEditMsg(
            API,
            formData,
            setIsShowModalEditMsg,
            msgContentList,
            msgEditSelected,
            setEditedMsgList,
            setStatusDeleteMsgList,
            statusDeleteMsgList,
            chatPostAllList,
            setChatPostUpdate,
            mentionsList,
            userChatList,
            ticketInfo,
            reloadTicketDetail,
            userDetail,
            attachFilesDelete,
            { ...itemChatPost, attachFiles }
        );
        setPostValue('');
        setCKEditorState('');
        setIsEditedMsgInprogress(false);
        setAttachFilesDelete([]);
    };

    const displayTransform = (id, display) => {
        let lastIndex = display.lastIndexOf(' ');
        let textDisplay = display.substr(0, lastIndex);
        return `@${textDisplay}`;
    };

    const handleSuggestion = e => {
        let lastIndex = e.display.lastIndexOf(' ');
        let textDisplay = e.display.substr(0, lastIndex);

        return (
            <div style={{ position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: ' 0 0 20px' }}>
                        <img
                            src={e.avatar}
                            alt=""
                            width={'20px'}
                            style={{ borderRadius: '50%', height: '20px' }}
                        />
                    </div>
                    <div
                        style={{
                            maxWidth: '280px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                            textAlign: 'left'
                        }}
                    >
                        <OverFlowTooltipWithTabsMui value={textDisplay} />
                        <OverFlowTooltipWithTabsMui value={e.mail} />
                    </div>
                </div>
            </div>
        );
    };

    // handle style for defaultMentionStyle
    const [lineHeight, setLineHeight] = useState('1');

    useEffect(() => {
        const handleResize = () => {
            if (editChatInputRef.current) {
                const currentInputHeight = editChatInputRef.current.clientHeight;
                if (currentInputHeight > 48) {
                    setLineHeight(null);
                } else {
                    setLineHeight('1');
                }
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);
        if (editChatInputRef.current) {
            resizeObserver.observe(editChatInputRef.current);
        }

        return () => {
            if (editChatInputRef.current) {
                resizeObserver.unobserve(editChatInputRef.current);
            }
            resizeObserver.disconnect();
        };
    }, [editChatInputRef.current]);

    const isSelectedTicketTypeAndThreadType = (ticketType, threadType) => {
        if (ticketInfo?.ticketType === ticketType && selectThread?.threadType === threadType) {
            return true;
        }
        return false;
    };

    const handleOnChangeCKEditor = (event, editor) => {
        try {
            const htmlContent = editor.getData();
            setCKEditorState(htmlContent);
        } catch (error) {
            console.log('handleOnChangeCKEditor', error)
        }
    }

    /**
     * Custom image upload to S3 storage.
     * 
     * Ref: https://ckeditor.com/docs/ckeditor5/latest/framework/deep-dive/upload-adapter.html
     */
    function uploadImageAdapterPlugin(editor) {
        try {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return handleUploadImageAdapter(loader);
            };
        } catch (error) {
            console.log('uploadImageAdapterPlugin', error)
        }
        
    }

    const handleUploadImageAdapter = (loader) => {
        return {
            upload: async () => {
                return loader.file.then((file)=>{
                    //setIsLoadingUploadFile(true)
                    return file
                }).then(async (file) => {
                    const result = await uploadFileToS3InTMPFolder(file);
                    let fileUpload = {
                        fileUrl: result.key,
                        type: Constant.S3_FILE_TYPE.TICKET_FILE
                    };
                    let link = await getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
                    return {
                        default: `${link}`
                    };
                }).finally( ()=>{
                    //setTimeout(()=> setIsLoadingUploadFile(false), 600)
                });
            }
        };
    }

    const renderEditInput = () => {
        const isEmailCustomerThread = isSelectedTicketTypeAndThreadType(
            Constant.TICKET_TYPE.EMAIL,
            Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD
        );

        if (!isEmailCustomerThread)
            return (
                <>
                 <div className="single-line">
                        <MentionsInput
                            onKeyDown={handleKeyDown}
                            forceSuggestionsAboveCursor={true}
                            allowSuggestionsAboveCursor={true}
                            value={chatPostValue}
                            onChange={onChangePost}
                            className="mentionWrapper"
                            style={{
                                ...defaultMentionStyle,
                                "&multiLine": {
                                    ...defaultMentionStyle["&multiLine"],
                                    input: {
                                        ...defaultMentionStyle["&multiLine"].input,
                                        lineHeight: lineHeight || undefined,
                                    },
                                },
                                suggestions : {
                                    ...defaultMentionStyle["suggestions"],
                                    item: {
                                        ...defaultMentionStyle["suggestions"]["item"],
                                        padding: '2px 14px 2px 14px',
                                    }
                                }
                            }}
                            classNames={classNames}
                            inputRef={editChatInputRef}
                        >
                            <Mention
                                className={classNames.mentions__mention}
                                trigger={/(?:^|\s)(@([^\s]*))$/}
                                // trigger="@"
                                displayTransform={displayTransform}
                                markup="@[__display__](__id__)"
                                data={notShowMention ? [] : listRenderMention}
                                renderSuggestion={handleSuggestion}
                                appendSpaceOnAdd={true}
                            />
                        </MentionsInput>
                    </div>
                </>
            );

        return (
            <>
                <div
                    id={`ckbox-${ckEditorId}`}
                    data-cy="richtext-editor"
                    className={`
                        editor edit-chat
                        sdesk-editor
                    `}
                >
                    <CKEditor
                        editor={window.CKEDITOR.ClassicEditor}
                        data={ckEditorState}
                        config={{
                            ...CkeditorConfiguration,
                            placeholder: I18n.get('PLACE-HOLDER'),
                            extraPlugins: [
                                SpecialCharactersEmoji,
                                uploadImageAdapterPlugin
                            ]
                        }}
                        onReady={editor => {
                            editor.ui.view.toolbar.element.style.display = 'none';
                            editor.model.document.on('change', (event, editorData) => {
                                handleOnChangeCKEditor(event, editor);
                            });
                        }}
                        onFocus={(event, editor) => {
                            window.editor = editor;
                            document
                                .querySelectorAll(
                                    `.editor .ck.ck-sticky-panel__content > .ck.ck-toolbar[aria-label="Editor toolbar"]`
                                )
                                .forEach(el => {
                                    el.style.display = 'none';
                                });
                            editor.ui.view.toolbar.element.style.display = 'block';
                        }}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="chatForm-edit">
            {!Utils.isEmptyArray(attachFilesCurrent) && (
                <div className="container-files-input">
                    {attachFilesCurrent.map((file, index) => {
                        if (Utils.isImageFile(file.fileInfo.fileName)) {
                            const params = {
                                fileUrl: file.fileInfo.fileUrl,
                                id: file.originId,
                                type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
                                chatThreadType: itemChatPost.chatThreadType,
                                sharedRange: itemChatPost.sharedRange,
                                content: file.fileInfo.fileName
                            };
                            const imgThumbnailLink = getLinkDownloadFileFromS3(
                                {
                                    ...params,
                                    thumbnailInfo: JSON.stringify(file.thumbnailInfo)
                                },
                                ticketInfo,
                                null,
                                Constant.ATTACH_FILE.VIEW_CHAT
                            );

                            const imgLink = getLinkDownloadFileFromS3(params, ticketInfo);
                            return (
                                <div className="container-image-item" key={file.id}>
                                    <img
                                        src={imgThumbnailLink}
                                        alt={`upload-${index}`}
                                        onClick={() =>
                                            setOpenPreviewImage(imgLink)
                                        }
                                        style={{
                                            borderRadius: 6,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div
                                        className="file-remove-btn"
                                        onClick={() => deleteFile(file)}
                                    >
                                        <CloseIcon style={{ width: 14, height: 14 }} />
                                    </div>
                                </div>
                            );
                        } else {
                            return (
                                <Tooltip
                                    title={file.fileInfo.fileName}
                                    placement="top"
                                    arrow
                                    key={file.id}
                                >
                                    <div className="container-file-item">
                                        <FileIcon
                                            style={{ width: 40, height: 40, color: '#2d72d2' }}
                                        />
                                        <div className="container-file-name-item">
                                            <span>{file.fileInfo.fileName}</span>
                                            <span>
                                                {file.fileInfo.fileName
                                                    .split('.')
                                                    .pop()
                                                    .toLowerCase()}
                                            </span>
                                        </div>
                                        <div
                                            className="file-remove-btn"
                                            onClick={() => deleteFile(file)}
                                        >
                                            <CloseIcon style={{ width: 14, height: 14 }} />
                                        </div>
                                    </div>
                                </Tooltip>
                            );
                        }
                    })}
                </div>
            )}
            {renderEditInput()}
            <div className="chatForm-edit-btn">
                <div className="chatForm-tools"></div>
                <div className="chatForm-btn">
                    <Button
                        className="btn-cancel btn-light btn-hg32"
                        variant="contained"
                        onClick={e => {
                            setIsShowModalEditMsg({ [msgEditSelected.id]: false });
                            setPostValue('');
                            setAttachFilesDelete([]);
                            setAttachFilesCurrent(attachFiles);
                        }}
                    >
                        キャンセル
                    </Button>
                    <Button
                        className="btn-apply btn-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={onEditChatPost}
                        disabled={isDisableBtnSave}
                    >
                        適用
                    </Button>
                </div>
            </div>
            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
}

EditChatPost.propTypes = {
    itemChatPost: PropTypes.any,
    attachFiles: PropTypes.any,
};